import { Close, Expand, ExpandMore, FilterList, SearchOutlined, Token } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary, capitalize, CircularProgress, Divider, IconButton, InputAdornment, TextField } from '@mui/material'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import PageContainer from '../components/PageContainer'
import { getList, getPublicResources, getToken } from '../redux/api/system'
import { dataTags, partners, searchCategories, searchResults } from '../util';
import CloseIcon from '@mui/icons-material/Close';
import { Formik, Form } from 'formik'

const Resources = ({ user }) => {
    const [ searching, setSearching ] = useState(false)
    const [ userData, setUserData ] = useState({});
    const [ domains, setDomains ] = useState([]);
    const [ institutions, setInstitutions ] = useState([]);
    const [ resources, setResources ] = useState([]);
    const [ filteredResources, setFilteredResources ] = useState([]);
    const [ filteredValue, setFilteredValue ] = useState('');
    const [ expandController, setExpandController ] = useState(-1)
    const [ fetching, setFetching ] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    
    const init = async () => {
        try {
            setFetching(true)

            const userId = user?.userData?.user_data?.userID || 'public';
            let token = null;

            if(userId == "public") {
                const resp = await getToken();
                if(resp?.responseCode === "00") {
                    token = resp?.token || null    
                } else {
                    enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
                }
            }

            const resp = await getPublicResources("user_resources", token);
            const resInstitutions = await getPublicResources("user_resources_inst", token);
            // const resInstitutions = await getPublicResources("fsrcc_resources", token);
            if(resp?.responseCode === "00") {
                const listing = resp?.listing || [];
                setDomains(listing)
                setInstitutions(resInstitutions?.listing || [])

                const resources = await new Promise((resolve) => {
                    let res = [];
                    let length = -1;
                    let count = -1;
                    length = length + (listing?.length || 0);

                    listing?.forEach(({ resourceGroups, ...lt }) => {

                        count += 1;
                        length = length + (resourceGroups?.length || 0);
                        
                        resourceGroups?.forEach(({ resources, ...rG}) => {
                            count += 1;

                            length = length + (resources?.length || 0);

                            resources?.forEach(rs => {
                                count += 1;
                                res.push({
                                    ...rs,
                                    ...rG,
                                    ...lt
                                })
                            })
                        })
                    })

                    if(length == count) resolve(res);
                })
                setResources(resources)

                setFilteredResources(resources)


            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setFetching(false)
        }
    }

    const filterList = (value, type) => {
        switch(type) {
            case 'inst':
                setFilteredValue(value.name)
                setFilteredResources(value.availableResources || []);
                break;
            case 'domain':
                setFilteredValue(value.domainName)
                setFilteredResources(resources?.filter(({ domainID }) => domainID == value?.domainID ) || []);
                break;
            default:
                setFilteredValue(''); 
                setFilteredResources(resources)
                break;
        }
    }

    const handleSearch = (event, value) => {
        if(event == "Enter"){
            setSearching(true);
            if(value == ""){
                setFilteredValue(''); 
                setFilteredResources(resources)
            }
            else {
                setFilteredValue(value);
                setFilteredResources((oldValue) => resources.filter((next) => (next.resourceName.toLowerCase().includes(value.toLowerCase())) || (next.tags.toLowerCase().includes(value.toLowerCase))));
            }
        }
    };

    const handleSubmit = ({ ...values }) => {
        //setSearching(oldValue => !oldValue);
        if(values.searchValue == ""){
            setFilteredValue(''); 
            setFilteredResources(resources)
        }
        else {
            setFilteredValue(values.searchValue);
            setFilteredResources((oldValue) => resources.filter((next) => (next.resourceName.toLowerCase().includes(values.searchValue.toLowerCase())) || (next.tags.toLowerCase().includes(values.searchValue.toLowerCase()))));
        }
    };

    useEffect(() => {
        init()
    }, [])

    useEffect(() => {
        setUserData(user)
    }, [user])
    
    return (
        <PageContainer processing={fetching}>
            <section className="inner-banner parallax-section">
                <div className='overlay' style={{ padding: '5.5rem 7.5rem' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center mb-2">
                                <h3 className="wow bounceIn mb-0" data-wow-delay="0.9s">Macroeconomic Statistics</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-3 mt-0" data-wow-delay="1.6s">Data Hub</h1>
                                <Formik
                                    enableReinitialize
                                    initialValues={{ searchValue : "" }}
                                    onSubmit={handleSubmit}
                                >
                                    {({ isSubmitting, values, setFieldValue, resetForm }) => (
                                        <Form>
                                            <TextField className='search-input' fullWidth placeholder='Search records'
                                                id='searchValue'
                                                value={values.searchValue}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            {
                                                                searching ? 
                                                                <IconButton
                                                                    edge="end"
                                                                    onClick={() => {setSearching(false); resetForm(); filterList()}}
                                                                >
                                                                    <CloseIcon />
                                                                </IconButton>
                                                                :
                                                                <IconButton
                                                                    edge="end"
                                                                    type='submit'
                                                                    onClick={() => setSearching(true)}
                                                                >
                                                                    <SearchOutlined />
                                                                </IconButton>
                                                            }
                                                        </InputAdornment>
                                                    )
                                                }}
                                                onChange={(e) => setFieldValue('searchValue', e.target.value)}
                                                onKeyDown={(e) => {handleSearch(e.code, e.target.value)}}
                                            />
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <section className="blog_area single-post-area section-padding">
                <div className="container">
                    <div className="row search-aside">
                        <div className="col-lg-4">
                            <div className="blog_right_sidebar">
                                <aside className="single_sidebar_widget post_category_widget">
                                    <h4 className="widget_title mb-1">Data Domain</h4>
                                    <ul className="list cat-list mb-0">
                                        {
                                            domains.map((domain, index) => (
                                                <li key={index}>
                                                    <Accordion className='sidebar-accordion' expanded={expandController == index}>
                                                        <AccordionSummary expandIcon={<ExpandMore onClick={() => setExpandController((expandController == index) ? -1 : index)} />}>
                                                            <p onClick={() => filterList(domain, 'domain')} style={{ cursor: 'pointer', margin: 0 }}>
                                                                {domain.domainName} ({resources?.filter(({ domainID }) => domainID == domain.domainID)?.length || 0})
                                                            </p>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <ul style={{ marginLeft: '2rem' }}>
                                                                {
                                                                    domain.resourceGroups?.map((group, key) => (
                                                                        <li key={key} style={{ padding: '1rem 0' }}>
                                                                            <Link to={`#`}>
                                                                                <p className='m-0'>{group.name} ({resources?.filter(({ resourceGroupID }) => resourceGroupID == group?.id)?.length || 0})</p>
                                                                            </Link>
                                                                        </li>
                                                                    ))
                                                                }
                                                            </ul>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                    
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </aside>
                                <aside className="single_sidebar_widget post_category_widget">
                                    <h4 className="widget_title">Available Data by Institution</h4>
                                    <ul className="list cat-list">
                                        {
                                            institutions.map((inst, index) => (
                                                <li key={index} onClick={() => filterList(inst, 'inst')} style={{ cursor: 'pointer' }}>
                                                    <p>{capitalize(inst.name || '')} ({ inst?.availableResources?.length || 0 })</p>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </aside>
                                {/* <aside className="single_sidebar_widget tag_cloud_widget">
                                    <h4 className="widget_title">Data Tag</h4>
                                    <ul className="list">
                                        {
                                            dataTags.map((tag, key) => (
                                                <li key={key}>
                                                    <Link to="/">{tag}</Link>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </aside> */}
                            </div>
                        </div>

                        <div className="col-lg-8 mb-5 mb-lg-0">
                            <div className="blog_left_sidebar">
                                { filteredValue && <p className='text-right'>Filtered By: {filteredValue} <IconButton onClick={() => { filterList() }}><Close /></IconButton></p> }
                                {
                                    (filteredResources?.length > 0) ?
                                    <>
                                        {
                                            filteredResources.map((res, key) => (
                                                <article className="blog_item mb-4" key={key} style={{ borderBottom: '1px solid lightgrey', paddingBottom: '2.5rem' }}>
                                                    <div className="blog_details pt-0">
                                                        <Link className="d-inline-block" to={`/view/${res.resourceID}`}>
                                                            <h4 className='f-22'>{res.resourceName}</h4>
                                                        </Link>
                                                        <div className='d-flex tags'>
                                                            <ul className="blog-info-link">
                                                                <li>Source: <Link to="/">{res.providedBy}</Link></li>
                                                                <li>Frequency: <Link to="/">{res.frequency}</Link></li>
                                                            </ul>
                                                            <span className='details-date'>{res.lastUpdated}</span>
                                                        </div>
                                                        {/* <div className='d-flex tags'>
                                                            <ul className="blog-info-link">
                                                                <li>Resource Group: <Link to="/">{res.name}</Link></li>
                                                            </ul>
                                                        </div> */}
                                                       
                                                        <p className='mb-05'>
                                                            <LinesEllipsis
                                                                text={`Description: ${res.description}`}
                                                                maxLine='3'
                                                                ellipsis='...'
                                                                trimRight
                                                                basedOn='letters'
                                                            />
                                                        </p>
                                                        <ul className="custom-tags mt-1">
                                                            {
                                                                String(res?.tags)?.split(',')?.map((tag, key) => (
                                                                    Boolean(tag) &&
                                                                    <li key={key}>
                                                                        <Link to="/">{tag}</Link>
                                                                    </li>
                                                                ))
                                                            }
                                                        </ul>
                                                    </div>
                                                </article>
                                            ))
                                        }
                                        {/* <nav className="blog-pagination justify-content-center d-flex">
                                            <ul className="pagination">
                                                <li className="page-item">
                                                    <a href="#" className="page-link" aria-label="Previous">
                                                        <i className="ti-angle-left"></i>
                                                    </a>
                                                </li>
                                                <li className="page-item">
                                                    <a href="#" className="page-link">1</a>
                                                </li>
                                                <li className="page-item active">
                                                    <a href="#" className="page-link">2</a>
                                                </li>
                                                <li className="page-item">
                                                    <a href="#" className="page-link" aria-label="Next">
                                                        <i className="ti-angle-right"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </nav> */}
                                    </>
                                    :
                                    <>
                                        <p className='text-center f-18'>No Resources Available!!!</p>
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </PageContainer>

    )
}

export default connect(({ user }) => ({ user }))(Resources)